import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ModuloAnaliticoResumo {
  codigo: string;
  titulo: string;
  descricao: string;
  status: string;
}

export interface AnaliseCartaoCreditoResultado {
  aba_encontrada: boolean;
  aba_lida: string;
  abas_disponiveis: string[];
  colunas: string[];
  linhas: any[];
  total_registros: number;
  resumo?: any;
}

@Injectable({ providedIn: 'root' })
export class ModulosAnaliticosService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api';

  listar(): Observable<ModuloAnaliticoResumo[]> {
    return this.http.get<ModuloAnaliticoResumo[]>(`${this.apiUrl}/modulos-analiticos`);
  }

  analisarCartaoCredito(file: File): Observable<AnaliseCartaoCreditoResultado> {
    const form = new FormData();
    form.append('file', file);
    return this.http.post<AnaliseCartaoCreditoResultado>(`${this.apiUrl}/analise/cartao-credito`, form);
  }

  baixarRelatorioCartaoCredito(file: File): Observable<Blob> {
    const form = new FormData();
    form.append('file', file);
    return this.http.post(`${this.apiUrl}/analise/cartao-credito/relatorio`, form, {
      responseType: 'blob'
    });
  }
}
